import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  Router,
  RouteConfigLoadStart,
  ResolveStart,
  RouteConfigLoadEnd,
  ResolveEnd
} from "@angular/router";
import { Subscription } from "rxjs";
import { buffer, debounceTime } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { SharedDataService } from "../services/shared.service";
import {
  VideoAlertCreated,
  VideoEventsStreamService,
} from "../services/video-events-stream.service";
// import { SharedDataService } from "../../IoTCore/dashboard-builder/services/shared.service";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.css"]
})
export class LayoutComponent implements OnInit, OnDestroy {
  sidebarCollapsed = false;
  private alertsSub: Subscription;
  constructor(
    private router: Router,
    public _SharedService: SharedDataService,
    private videoEventsStream: VideoEventsStreamService,
    private toastr: ToastrService
    ) {}
  moduleLoading = true;
  sideBarLoaded = false;

  public ngOnInit() {
    // One real-time connection for the whole authenticated app (closes on sign-out).
    this.videoEventsStream.acquire();
    // App-wide alert message; each page refreshes its own data via liveUpdate$.
    const alerts$ = this.videoEventsStream.videoAlerts$;
    this.alertsSub = alerts$
      .pipe(buffer(alerts$.pipe(debounceTime(300))))
      .subscribe((batch) => this.announceAlerts(batch));

    // this.sideBarLoaded = this._SharedService.isSidebarLoaded;

    this.router.events.subscribe(event => {
      if (
        event instanceof RouteConfigLoadStart ||
        event instanceof ResolveStart
      ) {
        this.moduleLoading = true;
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.moduleLoading = false;
      }
    });
    setTimeout(() => {
      window.scrollTo(0, 0);
      this.moduleLoading = false;
    }, 2000);
  }

  public ngOnDestroy() {
    if (this.alertsSub) {
      this.alertsSub.unsubscribe();
    }
    this.videoEventsStream.release();
  }

  private announceAlerts(batch: VideoAlertCreated[]) {
    if (batch.length === 1) {
      this.toastr.warning(this.alertName(batch[0].label), "New alert detected");
    } else if (batch.length > 1) {
      const names = Array.from(new Set(batch.map((a) => this.alertName(a.label))));
      const summary = names.length <= 3 ? names.join(", ") : `${names.slice(0, 3).join(", ")} and more`;
      this.toastr.warning(summary, `${batch.length} new alerts detected`);
    }
  }

  /** "intruderAlertDetected" -> "Intruder Alert Detected" */
  private alertName(label: string | null) {
    if (!label) {
      return "Video alert";
    }
    const words = label.replace(/[_-]+/g, " ").replace(/([a-z0-9])([A-Z])/g, "$1 $2").trim();
    return words.charAt(0).toUpperCase() + words.slice(1);
  }

  sidebarCollapse($event) {
    
    this.sidebarCollapsed = $event.sidebarCollapsed;
  }
}
